import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useRef } from "react";
import { useUserContext } from "../context/DealerProfile.jsx";
import useSWR from "swr";

const LeadProfile = ({ }) => {
  const [fields, setFields] = useState([]);
  const [lead, setLead] = useState(null);
  const [isFieldsLoading, setIsFieldsLoading] = useState(true);
  const { id } = useParams();
  const dealerDetail = useState(useUserContext);
  const [formData, setFormData] = useState(null);
  const [errors, setErrors] = useState({});
  const [options, setOptions] = useState({});
  const [sections, setSections] = useState([]);
  const module = "Indent_Request";

  const navigate = useNavigate();

  const idToFetch = id;


  // useEffect(() => {
  //   const fetchFieldsAndSections = async () => {
  //     const response = await fetch("/server/dealer_backend/getLayout?module=Leads");
  //     const data = await response.json();

  //     // console.log("Raw data:", data);

  //     if (data.status === "success") {
  //       // 🔍 Find layout with layout_name === "IFR"
  //       const ifrLayout = data.data.find(layout => layout.layout_name === "IFR");

  //       if (!ifrLayout) {
  //         console.warn("No layout with layout_name === 'IFR' found.");
  //         return;
  //       }

  //       // console.log("IFR Layout:", ifrLayout);

  //       // ✅ Extract usable sections from IFR layout
  //       const usableSections = ifrLayout.sections
  //         .filter(section => Array.isArray(section.fields) && section.fields.some(f => f.type === "used"))
  //         .map(section => ({
  //           ...section,
  //           fields: section.fields.filter(f => f.type === "used")
  //         }));

  //       // console.log("Usable sections from IFR layout:", usableSections);

  //       const allFilteredFields = usableSections.flatMap(
  //         (section) => section.fields
  //       );

  //       setSections(usableSections);
  //       //  const leadSourceField = allFilteredFields.find(
  //       //   (f) => f.display_label === "Contact Preferences"
  //       // );


  //       // setFormData((prev) => ({
  //       //   ...prev,
  //       //   ...(leadSourceField ? { [leadSourceField.name]: lead?.Contact_Method } : {}),

  //       // }));

  //     }
  //   };

  //   fetchFieldsAndSections();
  // }, []);

  const fetcher = (url) => fetch(url).then((res) => res.json());

  const { data, error, isLoading } = useSWR(
    `/server/dealer_backend/getLayout?module=${module}`,
    fetcher
  );

  useEffect(() => {
    if (error) {
      // console.error("Failed to fetch layout data:", error);
      setIsFieldsLoading(false);
      return;
    }
    if (data) {
      setIsFieldsLoading(false);

      if (data.status === "success") {
        const layout = data.data.find((layout) => layout.layout_name === "Standard");

        if (!layout) {
          // console.warn("No layout with layout_name === 'IFR' found.");
          return;
        }

        const usableSections = layout.sections
          .filter(
            (section) =>
              Array.isArray(section.fields) &&
              section.fields.some((f) => f.type === "used")
          )
          .map((section) => ({
            ...section,
            fields: section.fields.filter((f) => f.type === "used"),
          }))
          .filter((section) => section.fields.length > 0);

        const allFilteredFields = usableSections.flatMap(
          (section) => section.fields
        );

        setSections(usableSections);
        setFields(allFilteredFields);

        // Set default values for IFR Lead Source and Nationality
        // 🔁 Set default Lead Status to "New Lead"
        const leadStatusField = allFilteredFields.find(f => f.display_label === "Lead Status");
        if (leadStatusField) {
          setFormData(prev => ({
            ...prev,
            [leadStatusField.name]: "Start"
          }));
        }
        // ✅ Set default Lead User and Email
        const leadUserField = allFilteredFields.find(f => f.display_label === "Lead  User");
        if (leadUserField && dealerDetail?.Name) {
          setFormData(prev => ({
            ...prev,
            [leadUserField.name]: dealerDetail.Name,
            Mobile_User_Email: dealerDetail.Email || ""
          }));
        }
      } else {
        // console.error("Failed to fetch layout data:", data.error);
      }
    }
  }, [data, error]);
  const handleInputChange = useCallback((e) => {
    const { name, type, value, checked } = e.target;

    const newValue = type === "checkbox" ? checked : value;

    // Validation
    let error = "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (name === "Email" && newValue && !emailRegex.test(newValue)) {
      error = "Please enter a valid email address.";
    }

    if (name === "Mobile" && newValue && !phoneRegex.test(newValue)) {
      error = "Phone number must be a 10-digit number.";
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  }, []);

  useEffect(() => {
    const listValues = async () => {
      const module = "Leads";
      try {
        const response = await fetch(`/server/dealer_backend/getDataTypes?module=${module}`);
        const data = await response.json();
        // console.log(data);

        if (data.status === "success") {
          setFields(data.data);
        } else {
          // console.error("Failed to fetch  values:", data.error);
        }
      } catch (error) {
        // console.error("Error fetching  values:", error);
      }
    };

    listValues();
  }, []);

  useEffect(() => {
    const fetchLeadData = async () => {
      setIsFieldsLoading(true);
      try {
        const response = await fetch(`/server/dealer_backend/getSpecificLeadEdit?id=${idToFetch}`);
        const data = await response.json();

        // console.log(data)


        if (data.status === "success") {
          const filteredLead = data.data.find((item) => item.id === idToFetch);
          // console.log(data.data[0])
          // console.log(data.data[0])
          if (data.data[0]) {
            setLead(data.data[0]);
            setFormData(data.data[0]);
          }
        } else {
          // console.error("Error fetching data:", data.error);
        }
      } catch (error) {
        // console.error("Failed to fetch lead data:", error);
      } finally {
        setIsFieldsLoading(false);
      }
    };

    fetchLeadData();
  }, [idToFetch]); // Re-fetch when idToFetch changes

  const handleFieldChange = async (label, value) => {
    // console.log(label)
    const apiName = labelToApiNameMap.current[label];
    const updatedFormData = { ...formData, [apiName]: value };


    if (label === "Zip Code" && value.length === 6) {
      try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${value}`);

        const data = await response.json();
        // console.log("API response:", data[0].PostOffice[0]);

        if (data[0].PostOffice[0] && data[0].PostOffice[0].State && data[0].PostOffice[0].District) {
          updatedFormData[labelToApiNameMap.current["City"]] = data[0].PostOffice[0].District;
          updatedFormData[labelToApiNameMap.current["State"]] = data[0].PostOffice[0].State;
          updatedFormData[labelToApiNameMap.current["Country"]] = data[0].PostOffice[0].Country || "India";
        }
      } catch (err) {
        // console.error("Deluge API call failed:", err);
      }
    }



    setFormData(updatedFormData);
  };


  // Function to fetch picklist values
  const fetchPickListValues = async (id) => {
    // console.log(id)
    const module = "Indent_Request";
    try {
      const response = await fetch(`/server/dealer_backend/getPickListValues/${id}?module=${module}`);
      const data = await response.json();

      if (data.status === "success") {
        setOptions((prev) => ({
          ...prev,
          [id]: data.data,
        }));
      } else {
        // console.error("Failed to fetch pick list values:", data.error);
      }
    } catch (error) {
      // console.error("Error fetching pick list values:", error);
    }
  };

  const renderInputField = (field) => {
    const fieldValue = formData[field.name] || "";
    const isReadOnlyLeadStatus = field.display_label === "";

    // Special rendering for "Catalyst User"


    // Main switch
    switch (field.data_type) {
      case "integer":
      case "currency":
      case "bigint":
        if (field.display_label === "Donation Amount") {
          return (
            <input
              type="number"
              name={field.name}
              min="0"
              step="0.01"
              value={formData[field.name] || ""}
              onChange={(e) => {
                const value = parseFloat(e.target.value);
                if (value >= 0 || e.target.value === "") {
                  handleInputChange(e);
                }
              }}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none ${errors[field.name] ? "border-red-500" : "border-gray-300"
                }`}
            />
          );
        }

        return <input type="number" name={field.name} value={fieldValue} onChange={handleInputChange} step="0.01" />;


      case "datetime":
        return <input type="datetime-local" name={field.name} value={fieldValue} onChange={handleInputChange} />;

      case "date":
        return <input type="date" name={field.name} value={fieldValue} onChange={handleInputChange} />;

      case "text":
      case "email":
      case "ownerlookup":
      case "phone":
      case "website":
        // 👇 Special handling for First Name
        // if (field.display_label === "First Name") {
        //   return (
        //     <div className="flex w-[300px] rounded border overflow-hidden">
        //       {/* Salutation Dropdown */}
        //       <select
        //         className="px-2 py-2 bg-white border-r border-gray-300 outline-none focus:ring-0"
        //         value={formData.Salutation || ""}
        //         onChange={(e) => {
        //           const Salutation = e.target.value;
        //           setFormData(prev => ({
        //             ...prev,
        //             Salutation,
        //           }));
        //         }}
        //       >
        //         <option value="">-None-</option>
        //         <option value="Mr.">Mr.</option>
        //         <option value="Mrs.">Mrs.</option>
        //         <option value="Ms.">Ms.</option>
        //         <option value="Dr.">Dr.</option>
        //         <option value="Prof.">Prof.</option>
        //       </select>

        //       {/* First Name Input */}
        //       <input
        //         type="text"
        //         placeholder="Enter First Name"
        //         className="flex-1 px-2 py-2 outline-none focus:ring-0"
        //         value={formData.First_Name || ""}
        //         onChange={(e) => {
        //           const firstName = e.target.value;
        //           setFormData(prev => ({
        //             ...prev,
        //             First_Name: firstName, // ✅ Store clean first name
        //           }));
        //         }}
        //       />
        //     </div>
        //   );
        // }



        // 👇 Normal text/email/phone fields
        return (
          <div className="w-full">
            <input
              type={field.type}
              name={field.name}
              value={formData[field.name] || ""}
              onChange={(e) => {
                const val = e.target.value;
                if (field.display_label === "Zip Code") {
                  handleFieldChange(field.display_label, val);
                } else {
                  handleInputChange(e);
                }
              }}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none ${errors[field.name] ? "border-red-500" : "border-gray-300"
                }`}
            />
            {errors[field.name] && (
              <p className="text-sm text-red-500 mt-1">{errors[field.name]}</p>
            )}
          </div>
        );

      case "boolean":
        return <input type="checkbox" name={field.name} checked={formData[field.name] || false} onChange={handleInputChange} />;

      case "picklist":
        const picklistValues = options[field.id];
        return (
          <select
            name={field.name}
            value={fieldValue}
            onChange={isReadOnlyLeadStatus ? undefined : handleInputChange}
            disabled={isReadOnlyLeadStatus}
          >
            {!picklistValues ? (
              <option disabled>Loading...</option>
            ) : (
              picklistValues.map((option, idx) => (
                <option key={idx} value={option}>
                  {option}
                </option>
              ))
            )}
          </select>
        );

      case "profileimage":
        return <input type="file" name={field.name} onChange={handleInputChange} accept="image/*" />;

      case "lookup":
        return (
          <select name={field.name} value={fieldValue} onChange={handleInputChange}>
            {field.lookupValues?.length ? (
              field.lookupValues.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))
            ) : (
              <option disabled>No options available</option>
            )}
          </select>
        );

      default:
        return <input type="text" name={field.name} value={fieldValue} onChange={handleInputChange} />;
    }
  };

  const [isSaving, setIsSaving] = useState(false);


  const handleSave = async (e) => {
    e.preventDefault();
    // console.log("Updated Lead Data:", formData);
    const requiredFields = ["Part Source"];
    const api = labelToApiNameMap.current;

    // 1. Check if Status is "Interested Now"
    const statusValue = formData[api["Status"]];
    const idProofType = formData[api["ID Proof Type"]];
    const idProofNumber = formData[api["ID Proof Number"]];
    const subDisposition = formData["Sub_Disposition"]; // coming from your conditional field
    const ifrLeadSource = formData[api["IFR Lead Source"]];


    // Add conditional required fields
    if (statusValue === "Interested Now" || statusValue === "Interested Later") {
      if (!subDisposition || subDisposition.trim() === "") {
        toast.error("Please select a Sub Disposition.");
        return;
      }
    }

    const donationAmount = formData[api["Donation_Amount"]];
    if (donationAmount && parseFloat(donationAmount) < 0) {
      toast.error("Donation Amount cannot be negative.");
      return;
    }


    if (statusValue === "Interested Now" && ifrLeadSource === "Face to Face") {
      requiredFields.push("ID Proof Type");

      // Validate ID Proof Number based on selected type
      if (!idProofNumber || idProofNumber.trim() === "") {
        toast.error("Please enter ID Proof Number.");
        return;
      }

      // Validation based on selected proof type
      if (idProofType === "Aadhar Card" && !/^\d{12}$/.test(idProofNumber)) {
        toast.error("Please enter a valid 12-digit Aadhaar number.");
        return;
      }

      if (idProofType === "PAN Card" && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(idProofNumber)) {
        toast.error("Please enter a valid PAN number .");
        return;
      }

      if (idProofType === "Voter ID Card" && !/^[A-Z0-9]{10,}$/.test(idProofNumber)) {
        toast.error("Please enter a valid Voter ID.");
        return;
      }
    }
    const dobValue = formData["Date_of_Birth"];
    if (dobValue) {
      const dobDate = new Date(dobValue);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Strip time for accurate comparison

      if (dobDate > today) {
        toast.error("Date of Birth cannot be a future date.");
        return;
      }
    }



    const mobileLabel = "Mobile"; // change if your input label is different
    const mobileApiName = api[mobileLabel]; // gets the API field name for 'Phone'
    const mobileNumber = formData[mobileApiName];

    // Regex: exactly 10 digits, no letters, no symbols, no longer/shorter
  

    // Email validation
    const emailLabel = "Email"; // Change if your field label is different
    const emailApiName = api[emailLabel]; // Get API name for Email field
    const emailValue = formData[emailApiName]?.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;



    // 2. Check for missing required fields
    const missingFields = requiredFields.filter((label) => {
      const apiName = api[label];
      return !formData[apiName] || formData[apiName].trim() === "";
    });



    if (missingFields.length > 0) {
      toast.error(`Please fill the following required field(s): ${missingFields.join(", ")}`);
      return;
    }

    setIsSaving(true); // ✅ Set only after all validations pass

    // Remove Modified_By from the payload
    const { Modified_By, Layout,Defect_Code, ...updatedFormData } = formData;


    // console.log(lead?.Catalyst_ID)

    const requestBody = {
      data: [
        {
          ...updatedFormData,
          Owner: updatedFormData.Owner ? parseInt(updatedFormData.Owner, 10) : undefined,
          Created_By: updatedFormData.Created_By ? parseInt(updatedFormData.Created_By, 10) : undefined,
          Sub_Disposition: subDisposition,
          Catalyst_User: {
            id: lead?.Catalyst_ID
          }
        },
      ],
    };

    try {
      const response = await fetch(`/server/dealer_backend/edit-leadDetails/${idToFetch}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();

      if (result.status === "success") {
        toast.success("Request updated successfully!");
        navigate(`/request-details/${idToFetch}`);
      } else {
        // console.error("Error updating lead:", result.error);
        toast.error("Failed to update lead");
      }
    } catch (error) {
      // console.error("Error submitting update:", error);
      toast.error("An error occurred while updating the lead");
    } finally {
      setIsSaving(false); // ✅ Always reset
    }
  };




  const fieldGroups = {
    "Potential Donor Information": [
      "IFR Lead Sources", "First Name", "Last Name", "Email", "Mobile", "Secondary Email", "Phone", "PAN Number",
      // "Potential Donor Owner"
    ],
    "Address Information": ["Zip Code", "Street", "State", "City", "Country"],
    "Description Information": ["Description"],
    // "Catalyst User": ["Catalyst User", "Catalyst User Email", "Reporting Members"]

  };


  const dynamicFieldGroups = {
    ...fieldGroups, // base fields
  };

  // Conditionally inject "Face to Face" section
  if (formData?.IFR_Lead_Sources === "Face to Face") {
    dynamicFieldGroups["Face to Face Information"] = [
      "Meeting Location",
      "Region",
      "ID Proof Type",
      "ID Proof Number",
      "Nationality"
    ];
  }





  const labelToApiNameMap = useRef({});



  useEffect(() => {
    // Fetch picklist values
    sections.forEach((section) => {
      section.fields?.forEach((field) => {
        if (field.data_type === "picklist") {
          if (!field.id) {
            // console.warn("Missing field.id for picklist:", field);
          } else {
            fetchPickListValues(field.id);
          }
        }
      });
    });

    // Map display labels to field names
    const map = {};
    sections.forEach(section => {
      section.fields.forEach(field => {
        map[field.display_label] = field.name;
      });
    });
    labelToApiNameMap.current = map;
  }, [sections]);


  const interestedNowOptions = [
    "Donated on the spot",
    "Will donate later",
    "Asked for donation link",
    "Need more information/followup"
  ];

  const interestedLaterOptions = [
    "Already supporting",
    "Financial constraints",
    "Avoided conversation",
    "No reason given"
  ];


  return (
    <div className="LeadsPage">

      <ToastContainer position="top-right" autoClose={3000} />

      {(isFieldsLoading || !formData) ? (
        <div className="flex justify-center items-center h-screen">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
        </div>
      ) : (

        <div className="edit-container">

          <form>
            {/* Section 1: Basic Information - Two Columns */}
            <div className="form-section two-columns">
              <div className="lead-buttons flex flex-wrap">
                <h3 className="text-xl font-bold">Edit Indent Request</h3>
                <div>
                  {fields.length > 0 && (
                    <button
                      className="save-button mb-2"
                      onClick={handleSave}
                      disabled={isSaving}
                    >
                      {isSaving ? "Saving..." : "Save"}
                    </button>

                  )}

                  <button
                    className="cancel-button mb-2"
                    onClick={(e) => {
                      e.preventDefault(); // prevent any form-related default behavior
                      navigate(`/request-details/${idToFetch}`);
                    }}

                  >
                    Cancel
                  </button>

                </div>
              </div>
              <hr className="mb-4" />
              <div className="lead-form">
                {sections
                  .filter(section =>
                    section.type === "used" &&
                    !["Call Information", "Visit Summary", "Catalyst User", "System Information"].includes(section.display_label) &&
                    (section.display_label !== "Face to Face Information" ||
                      formData[labelToApiNameMap.current["IFR Lead Source"]] === "Face to Face")
                  )
                  .map(section => {
                    let sectionFields = section.fields.filter(
                      field => field.type === "used" && field.display_label
                    );

                    if (section.display_label === "Indent Request Information") {
                      const excludedFields = [
                        "Unsubscribed Time", "Gender", "Lead Status", "Purpose Type", "Donor Type", "Donor Potential Type",
                        "Contact Method", "Created By", "Lead Owner", "Modified By", "Full Name", "Salutation","Part Code","Indent Stages",
                        "Layout", "Currency", "Tag", "Donor type", "Last Activity Time","Technician","SPD","Model Code","CustomModule Owner",
                        "Record Status", "Lead Conversion Time", "Converted Date Time", "Modified Time", "Created Time",
                        "Exchange Rate", "Locked", "Enrich Status", "Last Enriched Time", "Change Log Time", "Record Id",
                        "Converted Deal", "Converted Account", "Is Converted", "Unsubscribed Mode", "Converted Contact", "PAN Number", "Sub Dispositions", "Event Name",
                        ...(formData[labelToApiNameMap.current["IFR Lead Source"]] !== "Face to Face"
                          ? ["Payment Type", "Donation Amount", "Mode of Payment"]
                          : []),
                        ...(formData[labelToApiNameMap.current["IFR Lead Source"]] === "Face to Face"
                          ? ["Call Dispositions"]
                          : []),
                        ...(formData[labelToApiNameMap.current["IFR Lead Source"]] === "Face to Face"
                          ? ["List Name"]
                          : [])
                      ];

                      sectionFields = sectionFields.filter(field => !excludedFields.includes(field.display_label));
                    }

                    if (section.display_label === "Description Information") {
                      const excludedFields = [
                        "Already a Existing Donor?", "Follow Up Date Time", "Number of RNR", "Last Call Date"
                      ];
                      sectionFields = sectionFields.filter(field => !excludedFields.includes(field.display_label));
                    }

                    if (sectionFields.length === 0) return null;

                    return (
                      <div key={section.display_label} className="form-section">
                        <h3>{section.display_label}</h3>
                        <div className={`form-section-fields grid grid-cols-1 gap-2 ${section.column_count === 2 ? "two-columns" : ""}`}>
                          {sectionFields.map((field) => {
                            const label = field.display_label;
                            const api = labelToApiNameMap.current;
                            const isStatusInterested = formData[api["Status"]] === "Interested Now";

                            if (label === "Status") {
                              return (
                                <div key={field.field_label} className="form-fields">
                                  <label htmlFor={field.field_label} className="block mb-1">
                                    {label} <span className="text-red-500">*</span>
                                  </label>
                                  {renderInputField(field)}

                                  {(formData[api["Status"]] === "Interested Now" ||
                                    formData[api["Status"]] === "Interested Later") && (
                                      <div className="form-fields mt-2">
                                        <label htmlFor={api["Sub Dispositions"]} className="block mb-1">
                                          Sub Dispositions
                                        </label>
                                        <select
                                          id={api["Sub Dispositions"]}
                                          name={api["Sub Dispositions"]}
                                          className="form-select border border-gray-300 p-2 w-full"
                                          value={formData[api["Sub Dispositions"]] || ""}
                                          onChange={(e) =>
                                            setFormData((prev) => ({
                                              ...prev,
                                              [api["Sub Dispositions"]]: e.target.value,
                                            }))
                                          }
                                        >
                                          <option value="">Select</option>
                                          {(formData[api["Status"]] === "Interested Now"
                                            ? interestedNowOptions
                                            : interestedLaterOptions
                                          ).map((option) => (
                                            <option key={option} value={option}>
                                              {option}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    )}
                                </div>
                              );
                            }

                            const alwaysRequired = ["Part Source"];
                            const conditionallyRequired = ["ID Proof Type", "ID Proof Number"];
                            const isAlwaysRequired = alwaysRequired.includes(label);
                            const isConditionallyRequired = isStatusInterested && conditionallyRequired.includes(label);

                            return (
                              <div key={field.field_label} className="form-fields">
                                <label htmlFor={field.field_label} className="block mb-1">
                                  {label}
                                  {(isAlwaysRequired || isConditionallyRequired) && (
                                    <span className="text-red-500"> *</span>
                                  )}
                                </label>
                                {renderInputField(field)}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}

              </div>


              {/* <div className="form-section">
                <div className="lead-form">
                  <h3>Description Information</h3>
                  <div className="form-fields-container">
                    {fields
                      .filter(field => ["Calling date", "Calling done by", "Description"].includes(field.label))
                      .map((field, index) => (
                        <div key={index} className="form-fields">
                          <label htmlFor={field.label.toLowerCase()}>{field.label}</label>
                          {renderInputField(field)}
                        </div>
                      ))}
                  </div>
                </div>
              </div> */}

            </div>




          </form>



        </div>
      )}
    </div>
  );
};

export default LeadProfile;
